import styled from "styled-components";

export const Container = styled.div`
  max-width: 1411px;
  padding: 50px 98px;
  margin: 0 auto;
  @media (max-width: 1250px) {
    padding: 15px;
  }
  .link-url {
    cursor: pointer;
    font-weight: bold;
    color: #0a5587;
    text-decoration: underline;
  }
  h3 {
    font-family: "latobold";
    font-size: 24px;
    text-decoration: underline;
  }
  p,
  i,
  li {
    font-size: 18px;
    text-align: justify;
  }
  ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
`;
